import {
  CoachingFormInputData,
  defaultCoachingFormValues,
  DeliveredStatusObject,
} from '../../api/CoachingForm/schema';

export const AWSDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss.SSSSZ';

export const initialCoachingValues: CoachingFormInputData = {
  ...defaultCoachingFormValues,
  isDelivered: DeliveredStatusObject.DRAFT,
};
